module.exports = __webpack_public_path__ + "static/images/containers/ClanPanel/components/Item/images/active.5234db99.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanPanel/components/Item/images/active.png
// module id = 3068
// module chunks = 11